import {
  SET_SEARCH_QUERY,
  SET_SEARCH_PAGE,
  SET_TAB_FILTER,
  SET_FORM_FILTERS,
  RESET_FORM_FILTERS,
  REMOVE_FILTER,
  SET_SEARCH_PARAMS,
  SET_REQUEST_RESULT,
} from "./reducer"

export const setSearchQuery = (query) => ({
  type: SET_SEARCH_QUERY,
  payload: { query },
})
export const setSearchPage = (pageNumber) => ({
  type: SET_SEARCH_PAGE,
  payload: { pageNumber },
})
export const setTabFilter = (resourceType) => ({
  type: SET_TAB_FILTER,
  payload: { resourceType },
})
/** `params`: search params built from the active filter tab (see filterConfig.toSearchParams). */
export const setFormFilters = (params) => ({
  type: SET_FORM_FILTERS,
  payload: { params },
})
export const resetFormFilters = () => ({
  type: RESET_FORM_FILTERS,
  payload: null,
})
/** Removes an applied filter; `value` removes a single value of a multi choice filter. */
export const removeFilter = (param, value) => ({
  type: REMOVE_FILTER,
  payload: { param, value },
})
export const setSearchParams = (locationSearchGroup) => ({
  type: SET_SEARCH_PARAMS,
  payload: { locationSearchGroup },
})
export const setRequestResult = (data, locationSearchGroup) => ({
  type: SET_REQUEST_RESULT,
  payload: { data, locationSearchGroup },
})
